import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["card"]

  connect() {
    // Under browser automation (system specs), skip the scroll-reveal animation
    // so cards below the fold are immediately visible to Capybara instead of
    // staying at opacity 0 until scrolled into the viewport.
    if (navigator.webdriver) {
      this.cardTargets.forEach((card) => { card.style.opacity = 1 });
      return;
    }

    const firstProjectObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = 1;
        } else {
          entry.target.style.opacity = 0;
        }
      });
    },
    {
      threshold: 0.16
    }
    );
    const secondProjectObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // entry.target.style.transform = "scale(1)";
        } else {
          // entry.target.style.transform = "scale(1.01)";
        }
      });
    },
    {
      threshold: 0.15
    }
    );
    this.cardTargets.forEach((card, i) => {
      firstProjectObserver.observe(card);
      secondProjectObserver.observe(card);
    });
  }
}
